
import { AuthStepsEnum, PaywallPlans, SiteLinks, PaywallAuthErrorCodes } from "../../../../global/paywall/paywallInterfaces";
import { getAuthHookFactory } from "../../../../global/paywall/useAuth";
import { PremiumPaywallDesktopSignupEmail } from "./signup/premiumPaywallDesktopSignupEmail"
import { PremiumPaywallDesktopSignupPassword } from "./signup/premiumPaywallDesktopSignupPassword"
import { PremiumPaywallState } from "./premiumPaywallDesktop";
import PremiumPaywallCheckoutPlans from "./premiumPaywallPlans";
import { useState, useEffect } from "react"


interface PremiumPaywallDesktopSignupProps {
  emailOrPhone: string
  password: string
  agreesTerms: boolean
  setEmailOrPhone: (emailOrPhone: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  setIsRedirecting: (isRedirect: boolean) => void
  selectedUrl?: string;
}


declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}


export const PremiumPaywallDesktopSignup = (props: PremiumPaywallDesktopSignupProps) => {
  const purchaseUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.purchase : '';
  const [selectedUrl, setSelectedUrl] = useState<string>(purchaseUrl);
  const { emailOrPhone, setEmailOrPhone, password, setPassword, setMode, agreesTerms, setAgreesTerms} = props
  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailOrPhoneForLogin,
    submitPassword,
    proceedToEmailStep,
    setAuthError
  } = getAuthHookFactory("signup", AuthStepsEnum.PLANS)();

  const sendMail = () => {
    sendEmailOrPhoneForLogin(emailOrPhone, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }

  
  const handleSelectPlan = (selectedPlan: string | null): string => {
    if (!selectedPlan || !purchaseUrl) return '';
    const url = new URL(purchaseUrl, window.location.origin);
    url.searchParams.set('selected', selectedPlan);
    setSelectedUrl(url.toString());
    return url.toString();
  };

  useEffect(() => {
    if (step === AuthStepsEnum.CONFIRM_TERMS && agreesTerms) {
      onThirdPartyLogin(agreesTerms)
    }
  }, [step]);

  useEffect(() => {
    if (/^\d+$/.test(emailOrPhone)) {
      setEmailOrPhone('');
    }
  }, []);


  switch (step) {
    case AuthStepsEnum.PLANS:
      return (
        <PremiumPaywallCheckoutPlans
          handleSelectPlan={handleSelectPlan}
          setMode={setMode}
          proceedToEmailStep={proceedToEmailStep}
          selectedUrl={selectedUrl}
        />)

    case AuthStepsEnum.EMAIL:
      return (
        <PremiumPaywallDesktopSignupEmail
          emailOrPhone={emailOrPhone}
          agreesTerms={agreesTerms}
          setEmailOrPhone={setEmailOrPhone}
          setAgreesTerms={setAgreesTerms}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
          setAuthError={setAuthError}

        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumPaywallDesktopSignupPassword
          emailOrPhone={emailOrPhone}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          sendMail={sendMail}
          authError={authError}
        />
      )


    case AuthStepsEnum.FINISH:
    location.href = selectedUrl || '';
      return null;
    default:
      return null
  }
};
